import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { isIE } from "react-device-detect";

//Actions
import { systemAnnouncementAction } from "CONFIG/ActionFactory";

//Components
import ScheduleSessionTable from "COMPONENTS/SessionManagement/ScheduleSessionTable/ScheduleSessionTableContainer";

//Change language 
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

//ASSETS
import icCalendar from "ASSETS/Images/menu_icons/icon_calendar.svg";
import icMeeting from "ASSETS/Images/menu_icons/icon_meeting.svg";
import icHistory from "ASSETS/Images/menu_icons/icon_history.svg";
import icCustomerManagement from "ASSETS/Images/menu_icons/icon_waiting.svg";
import icSupportCenter from "ASSETS/Images/menu_icons/icon_support.svg"

//UTILS
import { getAnnouncementUser, isAnnouncementBlank} from "UTILS/Utility";

//stylesheet
import "./SessionManagement.less";

class SessionManagement extends Component {

  constructor(props){
    super(props)
    this.state={
      activeAnnouncements: ""
    }
  }

  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };

  componentDidMount(){
  // get active announcements
    systemAnnouncementAction.getActiveAnnouncementsAction().then(
      (response) => {
        this.setState({
          activeAnnouncements: response.data
        })
      },
      error => {
        console.error(error);
      }
    )
  }

  render(){
    return(
      <div  className="container-fluid mt-4 sessionManagement">
        {this.state.activeAnnouncements && isAnnouncementBlank(this.state.activeAnnouncements, getMessage("AGENT_SCREEN")) &&
          <marquee>
            <label className="announcementLabel mt-2">
              {getAnnouncementUser(this.state.activeAnnouncements, window.location.href)}
            </label>
          </marquee>
        }
        <div className="languageSelection">
          <div className="language">
            <ChangeLanguage
              onSelectChange={this.onSelectChange}
              language={this.props.language}
            />
          </div>
        </div>
        <div className="sessionOptionsContainer col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
          {!this.props.isOperator &&
            <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv"
              onClick={this.props.showStartMeeting}>
              <img src={icMeeting} className={isIE ? "sessionImages" : ""}/>
              <span className="sessionOptions">{getMessage("START_A_MEETING")}</span>
            </div>
          }
          {/* Comment this for the future purposes */}
          {/* {!this.props.isOperator &&
            <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv"
              onClick={this.props.showScheduleMeeting}>              
              <img src={icCalendar} className={isIE ? "sessionImages" : ""}/>
              <span className="sessionOptions">{getMessage("CREATE_A_MEETING_APPOINTMENT")}</span>
            </div>
          } */}
          {this.props.isOperator &&
            <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv"
              onClick={this.props.showCallWaiting}>
              <img src={icSupportCenter} className={isIE ? "sessionImages" : ""}/>
              <span className="sessionOptions">{getMessage("SUPPORT_CENTER")}</span>
            </div>
          }
          <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv"
            onClick={this.props.showTrailHistory}>
            <img src={icHistory} className={isIE ? "sessionImages" : ""}/>
            <span className="sessionOptions">{getMessage("TRAIL_HISTORY")}</span>
          </div>
          {this.props.isAvailable === true &&
            <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv"
              onClick={this.props.showWaitingUsers}>
              <img src={icCustomerManagement} className={isIE ? "sessionImages" : ""}/>
              <span className="sessionOptions">{getMessage("QR_WAITING_USERS")}</span>
            </div>
          }
          {/*
          <div className="pt-2 d-flex flex-column text-center sessionOptionsDiv">
            <img src={icCustomerManagement} className={isIE ? "sessionImages" : ""}/>
            <span className="sessionOptions not-allowed">{getMessage("CUSTOMER_MANAGEMENT")}</span>
          </div>
          */}
        </div>
        {/* Hide this for the future purposes only */}
        {/* {!this.props.isOperator &&
          <div className="col-xl-12 pt-4 d-flex justify-content-center ScheduleSessionTable">
            <div className="col-xl-9 ScheduleSessionTable">
              <ScheduleSessionTable
                joinSession = {this.props.joinSession}
                editSessionRequest = {this.editSessionRequest}
                clearInputData = {this.clearInputData}
              />
            </div>
          </div>
        } */}
        {/* {!isIE && !isFirefox &&
            <div
              className="d-flex justify-content-center py-3"
            >
              <span  
                className="testPageLink cursorPointer text-center"
                onClick={() => {
                  window.open('/testPage', '_blank');
                }}>
                {getMessage("TEST_PAGE")}
              </span>
            </div>
        } */}
      </div>
    )
  }
}

export default SessionManagement;
